<template>
  <div>
    <base-header v-if="!hideHeaderAndFooter" />
    <base-quick-menu-sidebar v-if="!hideHeaderAndFooter" @quickMenuClickEvent="quickMenuClickEvent($event)" />
    <main class="px-0" :class="classByLoginStatus()">
      <router-view
        :pixi-canvas="pixiCanvas"
        :pixi-canvas-type="pixiCanvasType"
        @updateCanvas="setPixiCanvasElement()"
        @setPixiCanvasType="pixiCanvasType = $event"
        @setPixiCanvas="replacePixiCanvas($event)"
        @setPixiCanvasElement="getPixiCanvasElement($event)"
      >
        <div id="pixiCanvas" slot="pixi-canvas" class="onCanvas" />
      </router-view>
    </main>
    <base-alert />
  </div>
</template>

<script>
import BaseHeader from "./component/common/BaseHeader.vue";
import BaseQuickMenuSidebar from "./component/common/BaseQuickMenuSidebar.vue";
import BaseAlert from "./component/element/BaseAlert.vue";
import serviceResponseHelper from "./mixins/serviceResponseHelper";
import { destroyPixiInstance, pausePixiInstance, resumePixiInstance } from "./util/pixiCleanup";

export default {
  name: "App",
  components: { BaseAlert, BaseQuickMenuSidebar, BaseHeader },
  mixins: [serviceResponseHelper],
  data() {
    return {
      pixiCanvas: null,
      pixiCanvasType: null,
      customPixiCanvasElement: null,
      code: "",
    };
  },
  computed: {
    user: {
      get() {
        return this.$store.getters.getUser;
      },
      set(val) {
        this.$store.commit("setUser", val);
      },
    },
    loggedIn: {
      get() {
        return this.$store.getters.getLoggedIn;
      },
      set(val) {
        this.$store.commit("setLoggedIn", val);
      },
    },
    selectedUserUnitId: {
      get() {
        return this.$store.getters.getSelectedUserUnitId;
      },
      set(val) {
        this.$store.commit("setSelectedUserUnitId", val);
      },
    },
    environment: {
      get() {
        return this.$store.getters.getEnvironment;
      },
      set(val) {
        this.$store.commit("setEnvironment", val);
      },
    },
    isPasswordReset: {
      get() {
        return this.$store.getters.getIsPasswordReset;
      },
      set(val) {
        this.$store.commit("setIsPasswordReset", val);
      },
    },
    hideHeaderAndFooter: {
      get() {
        if (this.$route.meta.hideHeaderAndFooter) {
          return this.$route.meta.hideHeaderAndFooter;
        } else {
          return false;
        }
      },
      set(val) {
        val = false;
      },
    },
  },
  watch: {
    $route() {
      // Pixi tuvali yalnız onu kullanan sayfadayken DOM'da; sayfadan çıkınca örnek yeniden kullanım için saklanır ama
      // çizim döngüsü durdurulur. Sayfa updateCanvas ile tuvali geri takınca setPixiCanvasElement yeniden başlatır.
      this.$nextTick(() => {
        if (this.customPixiCanvasElement && !this.customPixiCanvasElement.isConnected) {
          pausePixiInstance(this.pixiCanvas);
        }
      });
    },
    selectedUserUnitId: {
      handler(val) {
        if (!val) {
          this.clearStore();
        }
      },
      deep: true,
    },
    loggedIn: {
      handler(val) {
        if (!val) {
          this.clearStore();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.$store.commit("reloadState");

    // Session base flow
    const generateUUID = () => {
      let d = new Date().getTime(); //Timestamp
      let d2 = (performance && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        let r = Math.random() * 16; //random number between 0 and 16
        if (d > 0) {
          //Use timestamp until depleted
          r = (d + r) % 16 | 0;
          d = Math.floor(d / 16);
        } else {
          //Use microseconds since page-load if supported
          r = (d2 + r) % 16 | 0;
          d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
      });
    };

    if (!window.name) {
      window.name = generateUUID();
      if (
        window.location.href === window.location.origin + "/satis-ekrani-koltuk-secimi" ||
        window.location.href === window.location.origin + "/satis-yonetimi-odeme" ||
        window.location.href === window.location.origin + "/satis-yonetimi-bilet-rezervasyon"
      ) {
        //TODO: Bilet akış başına yollanacağına dair bir mesaj
        alert("Yeni işlem için satis işlemleri sayfasına yönlendirileceksiniz.");
        // this.$router.push('/satis-islemleri');
        window.location = window.location.origin + "/satis-islemleri";
      } else if (this.$route.path === "/bilet-islemleri") {
        //TODO: Tekrar pnr sorgulama yapmalı mesaj
        alert("Tekrar Bilet Sorgulaması Yapılmalı");
        this.$store.commit("setGetReservationResponse", {});
      }
    } else {
      //TODO: koltuk seçim ekranına gitmeye çalışıyorsa, passengers kendi sessionId'sine göre dolu olmalı eğer değilse tekrar satis islemlerine gönderilecek.
      if (window.location.href === window.location.origin + "/satis-ekrani-koltuk-secimi" && !this.$store.getters.getPassengers) {
        window.location = window.location.origin + "/satis-islemleri";
      }
      //TODO: payment ekranına gitmeye çalışıyorsa, railBookingResponse'u kendi sessionIdsine göre dolu değilse tekrar satis islemlerine gönderilecek
      if (window.location.href === window.location.origin + "/satis-yonetimi-odeme" && !this.$store.getters.getRailBookingResponse) {
        window.location = window.location.origin + "/satis-islemleri";
      }
      //TODO: sonuc ekranına gitmeye çalışıyorsa, issueTicketResponse'u kendi sessionIdsine göre dolu değilse tekrar satis islemlerine gönderilecek
      if (window.location.href === window.location.origin + "/satis-yonetimi-bilet" && !this.$store.getters.getIssueTicketResponse) {
        window.location = window.location.origin + "/satis-islemleri";
      }
    }
    // console.log("window name: "+window.name);

    if (!this.loggedIn && window.location.href !== window.location.origin + "/giris-yap") {
      // this.callAlert(6,"Oturumunuzun süresi dolmuştur. Lütfen tekrar giriş yapınız.","warning","Oturum Süresi Doldu!","warning")
      this.clearStore();
      this.loggedIn = false;
      $(".modal").modal("hide");
      if (this.$route.path !== "/giris-yap") {
        this.$router.push("/giris-yap");
      }
      // window.location = window.location.origin + "/giris-yap";
    }
    $(document).on("focusin", (event) => {
      if ($(event.target).hasClass("vld-overlay")) {
        event.stopImmediatePropagation();
        return false; // jQuery için özel engelleme
      }
    });
  },
  created() {
    let uri = window.location.href.split("?");
    if (uri.length === 2) {
      let url = uri[1].slice(4);
      this.code = decodeURIComponent(url);
      // console.log(url);
    }
    if (uri[1] === undefined) {
      this.$store.commit("setIsPasswordReset", false);
    }
  },
  methods: {
    setPixiCanvasElement() {
      document.getElementById("pixiCanvas").appendChild(this.customPixiCanvasElement);
      resumePixiInstance(this.pixiCanvas);
    },
    getPixiCanvasElement(event) {
      this.customPixiCanvasElement = event[0];
    },
    replacePixiCanvas(pixiCanvas) {
      // Aynı türde sayfaya dönüşte örnek yeniden kullanılır; tür değişince eskisi kapatılmazsa WebGL bağlamı ve
      // her karede çizen ticker sekme kapanana kadar yaşar.
      if (this.pixiCanvas && this.pixiCanvas !== pixiCanvas) {
        destroyPixiInstance(this.pixiCanvas);
      }
      this.pixiCanvas = pixiCanvas;
    },
    quickMenuClickEvent(event) {
      if (event.sidebarRightClass) {
        event.activeDirectionMenu = "menuRight";
      } else {
        event.activeDirectionMenu = "menuLeft";
      }
    },
    classByLoginStatus() {
      if (!this.hideHeaderAndFooter) {
        return "customContainerFluid container";
      } else {
        return "container-fluid";
      }
    },
    clearStore() {
      this.$store.commit("setDefaultSelectedUser");
      this.$store.commit("setDefaultSelectedUserUnitId");
      this.$store.commit("setDefaultSelectedAgency");
      this.$store.commit("setDefaultSelectedAnnouncement");
      this.$store.commit("setDefaultSelectedAdditionalService");
      this.$store.commit("setDefaultSelectedBlacklistUser");
      this.$store.commit("setDefaultSelectedConnectingTrain");
      this.$store.commit("setDefaultSelectedBoxOffice");
      this.$store.commit("setDefaultSelectedCabinClass");
      this.$store.commit("setDefaultSelectedCar");
      this.$store.commit("setDefaultSelectedDiscountPackage");
      this.$store.commit("setDefaultSelectedFareFamily");
      this.$store.commit("setDefaultSelectedInformation");
      this.$store.commit("setDefaultSelectedItem");
      this.$store.commit("setDefaultSelectedItemProperty");
      this.$store.commit("setDefaultSelectedItemType");
      this.$store.commit("setDefaultSelectedItemGroup");
      this.$store.commit("setDefaultSelectedLine");
      this.$store.commit("setDefaultSelectedMainUnit");
      this.$store.commit("setDefaultSelectedNotification");
      this.$store.commit("setDefaultSelectedOrer");
      this.$store.commit("setDefaultSelectedPassengerType");
      this.$store.commit("setDefaultSelectedQuota");
      this.$store.commit("setDefaultSelectedSchedule");
      this.$store.commit("setDefaultSelectedStation");
      this.$store.commit("setDefaultSelectedSeatMapConnectingTemplate");
      this.$store.commit("setDefaultSelectedRole");
      this.$store.commit("setDefaultSelectedTrainSetMapping");
      this.$store.commit("setDefaultSelectedTrainSet");
      this.$store.commit("setDefaultSelectedSubscription");
      this.$store.commit("setDefaultSelectedSpecialServiceRequest");
      this.$store.commit("setDefaultSelectedSeatMap");
      this.$store.commit("setDefaultSelectedTicketClassRule");
      this.$store.commit("setDefaultSelectedParameter");
      this.$store.commit("setDefaultSelectedResourceGroup");
      this.$store.commit("resetBookingModule");
      this.$store.commit("resetGiseModule");
      this.$store.commit("resetPaymentModule");
      this.$store.commit("setDefaultAdditionalServicePricingModule");
      this.$store.commit("setDefaultAgentModule");
      this.$store.commit("setBookingClassModule");
      this.$store.commit("setDefaultCarModule");
      this.$store.commit("setDefaultCloseAccountModule");
      this.$store.commit("setDefaultAccountApproveModule");
      this.$store.commit("setDefaultCommissionModule");
      this.$store.commit("setDefaultCustomerModule");
      this.$store.commit("setDefaultEquivalentStationModule");
      this.$store.commit("setDefaultItemModule");
      this.$store.commit("setDefaultItemGroupTypeModule");
      this.$store.commit("setDefaultItemTypeModule");
      this.$store.commit("setDefaultLineModule");
      this.$store.commit("setDefaultMainUnitModule");
      this.$store.commit("setDefaultOrerModule");
      this.$store.commit("setDefaultParameterModule");
      this.$store.commit("setParkourBasedPricingModule");
      this.$store.commit("setDefaultPassengerTypeModule");
      this.$store.commit("setDefaultPositionModule");
      this.$store.commit("setDefaultPricingModule");
      this.$store.commit("setDefaultQuotaModule");
      this.$store.commit("setDefaultReportModule");
      this.$store.commit("setDefaultResourceModule");
      this.$store.commit("setDefaultResourceGroupModule");
      this.$store.commit("setDefaultRoleModule");
      this.$store.commit("setDefaultSaleChannelModule");
      this.$store.commit("setDefaultSeatMapModule");
      this.$store.commit("setDefaultSeferModule");
      this.$store.commit("setDefaultSegmentModule");
      this.$store.commit("setDefaultItemGroupModule");
      this.$store.commit("setDefaultKKYAccountTransferModule");
      this.$store.commit("setDefaultTrainSetMappingModule");
      this.$store.commit("setDefaultTimeSchedule");
      this.$store.commit("setDefaultRoleGroupModule");
      this.$store.commit("setDefaultStationStatusModule");
      this.$store.commit("setDefaultStationTypeModule");
      this.$store.commit("setDefaultUserModule");
    },
  },
};
</script>
